<template>
  <div v-if="loaded" class="index">
    <div v-if="!sucess" class="form">
      <div class="header-bg"></div>
      <div class="content-box" ref="contentBoxTop">
        <div class="title">{{ channelInfo.title_clue ? channelInfo.title_clue : '指南者留学免费评估' }}</div>
        <p class="intro">
          {{ channelInfo.desc_clue ? channelInfo.desc_clue : '欢迎使用指南者留学，填写详细信息有利于后续的精准推荐哦' }}
        </p>
        <div class="content">
          <van-cell-group>
            <!-- 姓名 -->
            <div class="form-item" ref="nameItemRef">
              <div class="form-item-label">姓名</div>
              <van-field
                class="form-item-field"
                v-model="form.name"
                placeholder="请输入姓名"
                clearable
                input-align="left"
                @focus="e=>onFocus(e, 'nameItemRef')"
                @blur="onBlur"
              ></van-field>
            </div>

            <!-- 手机号 -->
            <!-- <van-field
            v-if="!uid"
            v-model="form.phone"
            placeholder="必填"
            clearable
            label="手机号"
            input-align="right"
            class="needsClick"
            @focus="onFocus"
            @blur="onBlur"
          /> -->
            <div class="form-item" ref="phoneItemRef">
              <div class="form-item-label">
                <div class="star-icon">*</div>
                手机号
              </div>
              <van-field
                class="form-item-field needsClick preLine"
                v-if="!uid"
                v-model="form.phone"
                placeholder="请输入手机号"
                clearable
                :key="'phone' + fresh"
                input-align="left"
                @focus="e=>onFocus(e, 'phoneItemRef')"
                @blur="onBlur"
              >
                <template #text>
                  <span>一键获取</span>
                </template>
                <!-- <template #label>
                  <span class="van-cell__title van-field__label">手机号</span>
                  <router-link to="/areacode">
                    <span>+{{ aCode }} <van-icon name="arrow-down" /></span>
                  </router-link>
                </template> -->
              </van-field>
            </div>

            <!-- 微信号 -->
            <!-- <van-field
              v-if="!uid"
              v-model="form.wx_num"
              placeholder="非必填"
              clearable
              :key="'wx' + fresh"
              label="微信号"
              input-align="right"
              @focus="onFocus"
              @blur="onBlur"
            /> -->

            <!-- 本科院校类型 -->
            <!-- <van-field
              v-model="form.school_type"
              label="本科院校类型"
              placeholder="必选"
              readonly
              input-align="right"
              right-icon="arrow"
              class="needsClick"
              @click="openPopup('univ-type')"
            /> -->

            <!-- 本科院校名 -->
            <div class="form-item">
              <div class="form-item-label" ref="schoolLabelRef">
                <div class="star-icon">*</div>
                本科院校名称
              </div>
              <van-field
                v-model="schoolSearchName"
                placeholder="请输入选择本科院校名称"
                input-align="left"
                clearable
                class="needsClick form-item-field"
                @focus="e=>onSchoolFocus(e, 'schoolLabelRef')"
                @blur="onSchoolBlur"
              >
                <template #label>
                  <span class="van-cell__title van-field__label" @click.stop="openPopup('univ-type')">
                    <span class="label-name"> {{ form.school_type }}</span>
                    <span class="tri-icon"></span>
                    <div class="divide"></div>
                  </span>
                </template>
              </van-field>
              <ul class="school-list" v-if="schoolSearchName && schoolList.length && searchListShow">
                <li
                  class="school-list-item"
                  v-for="school of schoolList"
                  :key="school.id"
                  @click="onSchoolChange(school.id, school.college_name)"
                >
                  {{ school.college_name }}
                </li>
              </ul>
              <div class="school-list-empty" v-else-if="schoolSearchName && !schoolList.length && searchListShow">
                {{ _isOversea ? '没有查询到相关学校，支持输入自定义学校名' : '没有查询到相关的学校' }}
              </div>
            </div>

            <!-- 本科入学年份 -->
            <div class="form-item">
              <div class="form-item-label">
                <div class="star-icon">*</div>
                本科入学年份
              </div>
              <div class="radio-btn-group">
                <van-button
                  :class="form.bacherlor_in_year == item ? 'radio-btn radio-active-btn' : 'radio-btn'"
                  v-for="item in yearList"
                  :key="item"
                  plain
                  @click="onYearConfirm(item)"
                >
                  {{ item }}
                </van-button>
              </div>
            </div>
            <!-- <van-field
              v-model="form.bacherlor_in_year"
              label="本科入学年份"
              placeholder="必选"
              readonly
              input-align="right"
              right-icon="arrow"
              class="needsClick"
              @click="openPopup('year')"
            /> -->
            <div class="form-item">
              <div class="form-item-label">
                <div class="star-icon">*</div>
                留学意向地区
                <div class="tip">多选</div>
              </div>
              <van-checkbox-group class="check-btn-group" v-model="form.area_study">
                <van-checkbox class="check" v-for="ctry of targetCtrys" :key="ctry.value" :name="ctry.value">
                  <van-button
                    :class="form.area_study.includes(ctry.value) ? 'active-checked-btn check-btn' : 'check-btn'"
                    @click="clickArea()"
                    >{{ ctry.name }}</van-button
                  >
                </van-checkbox>
              </van-checkbox-group>
            </div>
          </van-cell-group>

          <!-- 年份选择 -->
          <!-- <van-popup v-model="yearPopupShow" position="bottom">
            <van-picker show-toolbar :columns="yearList" @cancel="onPopupCancel" @confirm="onYearConfirm" />
          </van-popup> -->
          <!-- 本科院校名 -->
          <van-popup v-model="univNamePopupShow" position="bottom" @close="onPopupClose">
            <div class="popup-school">
              <div class="popup-header">
                <div class="popup-header__tip">请选择你的学校</div>
                <div class="popup-header__icon iconfont" @click="univNamePopupShow = false"></div>
              </div>
              <div class="popup-body">
                <div class="popup-search">
                  <span :class="['search__input']">
                    <input
                      type="text"
                      @focus="onFocus"
                      @blur="onBlur"
                      v-model="schoolSearchName"
                      placeholder="请输入学校名称"
                    />
                    <span class="iconfont search__search" @click="onSearchSchoolClick"></span>
                  </span>
                  <span class="search__cancel" @click="univNamePopupShow = false">取消</span>
                </div>
                <div class="popup-schoollist">
                  <div class="popup-school__loading" v-if="schoolSearchLoading">
                    <loading-page :loading="schoolSearchLoading"> </loading-page>
                  </div>
                  <div class="schoollist-null" v-if="!schoolSearchLoading && 0 == schoolList.length">
                    没有搜索到的学校
                  </div>
                  <div class="schoollist-list" v-else>
                    <div
                      :class="[
                        'schoollist-list__item',
                        { 'schoollist-list__item--selected': form.sch_id == school.id }
                      ]"
                      v-for="school of schoolList"
                      :key="school.id"
                      @click="onSchoolChange(school.id, school.college_name)"
                    >
                      {{ school.college_name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-popup>
        </div>
        <div v-if="targetCtrys.length > 0" class="bottom">
          <cpu-button
            class="btn-submit"
            :text="channelInfo.btn_clue ? channelInfo.btn_clue : '获取评估信息'"
            @click.native="submit"
          ></cpu-button>
        </div>
      </div>
      <!-- 本科院校类型 -->
      <van-popup v-model="univTypePopupShow" position="bottom">
        <van-picker show-toolbar :columns="univList" @cancel="onPopupCancel" @confirm="onUnivTypeConfirm" />
      </van-popup>
    </div>
    <div v-if="sucess" class="result" ref="result">
      <div class="result__logo"><img src="../assets/img/sucess.png" /></div>
      <div class="result__title">提交成功</div>
      <div class="result__tip result__tip1">顾问老师会在第一时间提供专业咨询建议</div>
      <div v-if="!miniprogram" class="result__tip result__tip2">了解更多留学信息请下载指南者留学App</div>
      <div v-else class="result__tip result__tip2">了解更多留学信息可以在应用市场搜索指南者留学App</div>
      <cpu-button v-if="!miniprogram" class="btn-submit" text="下载指南者留学App" @click.native="download"></cpu-button>
      <cpu-button v-else class="btn-submit" text="返回" @click.native="closeWebview"></cpu-button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import cpuButton from '@/components/cpu-button'
import loadingPage from '@/components/loading-page'

import api from '@/api/'
import { Toast } from 'vant'
import wx from 'weixin-js-sdk'

export default {
  name: 'index',
  data() {
    return {
      uid: null,
      sucess: false,
      channel_code: '',
      loaded: false,
      ask_url: '',
      view_url: '',
      token: null,
      form: {
        name: '',
        wx_num: '',
        phone: '',
        school_type: '国内本科',
        school: '',
        sch_id: '',
        bacherlor_in_year: '',
        area_study: []
      },
      univTypePopupShow: false,
      univList: ['国内本科', '海外本科'],
      // yearPopupShow: false,
      yearList: [],
      univNamePopupShow: false,
      schoolList: [],
      schoolSearchName: '',
      schoolSearchLoading: false,
      targetCtrys: [],
      isFocus: false,
      miniprogram: false,
      fresh: 0,
      value1: 0,
      searchListShow: false,
      channelInfo: {
        title_clue: '指南者留学免费评估',
        desc_clue: '欢迎使用指南者留学，填写详细信息有利于后续的精准推荐哦',
        btn_clue: '获取评估信息'
      },
      checked: false,
      contentBoxTop: 0
    }
  },
  components: {
    cpuButton,
    loadingPage
  },
  created() {
    if (this.$route.query.uid) {
      this.uid = this.$route.query.uid
    }
    if (this.$route.query.code) {
      this.channel_code = this.$route.query.code
    }
    if (this.$route.query.askurl) {
      this.ask_url = decodeURIComponent(this.$route.query.askurl)
    }
    if (this.$route.query.viewurl) {
      this.view_url = decodeURIComponent(this.$route.query.viewurl)
    }

    this.debounceSchoolName = this.$debounce(this.onSearchSchoolClick, 200)
  },
  mounted() {
    // 判断是否在小程序中
    this.isInWeChatMP().then(res => {
      if (res) {
        this.miniprogram = true
      }
    })
    this.init()
  },
  watch: {
    schoolSearchName() {
      this.debounceSchoolName()
    }
  },
  computed: {
    _isOversea() {
      return '海外本科' == this.form.school_type
    },
    ...mapState(['aCode'])
  },
  methods: {
    async init() {
      // eslint-disable-next-line no-unused-vars
      const [res1, res2] = await Promise.all([api.getApplicationYears(), api.getCountrys()])
      if (this.channel_code) {
        const res3 = await api.getChannelInfo(this.channel_code)
        if (res3.data) {
          this.channelInfo = res3.data
        }
      }

      this.yearList = res1.data.list
      // const limitCtrys = [7, 12, 11, 13, 10, 9]
      // this.targetCtrys = limitCtrys.map(item2 => res2.data.find(item => item.id == item2))
      this.targetCtrys = res1.data.forward_country_conf
      this.loaded = true

      this.$nextTick(() => {
        console.log(999)
        console.log(111, this.$refs.contentBoxTop.getBoundingClientRect().top)
        this.contentBoxTop = this.$refs.contentBoxTop.getBoundingClientRect().top
      })
    },
    isValidURL(string) {
      try {
        new URL(string)
        return true
      } catch (_) {
        return false
      }
    },
    submit() {
      if (!this.uid && !this.form.phone) {
        Toast('请填写手机号')
        return
      }
      if (this.aCode == 86 && !/^1\d{10}$/.test(this.form.phone)) {
        Toast('手机号填写错误，请重新填写！')
        return
      }
      if (!this.uid && !this.form.school && !this._isOversea) {
        Toast('请选择本科院校学院！')
        return
      }
      if (!this.uid && !this.form.school && this._isOversea) {
        Toast('请选择学校或填写学校名称')
        return
      }
      if (!this.uid && !this.form.bacherlor_in_year) {
        Toast('请选择本科入学年份！')
        return
      }
      if (!this.uid && (!this.form.area_study || !this.form.area_study.length)) {
        Toast('请选择至少一个留学意向地区！')
        return
      }
      var params = {
        name: this.form.name,
        school: this.form.school,
        bacherlor_in_year: this.form.bacherlor_in_year,
        area_study: this.form.area_study.join(','),
        channel_code: this.channel_code,
        ask_url: this.ask_url,
        view_url: this.view_url
      }
      if (this.uid) {
        params.uid = this.uid
      } else {
        params.wx_num = this.form.wx_num
        params.phone = this.aCode + '-' + this.form.phone
      }
      if (this.form.school_type) {
        params.school_type = this._isOversea ? 0 : 1
      }
      params.sch_id = this.form.sch_id

      // console.log('getSendData', params)

      api
        .addCluebym(params)
        .then((res) => {
          const url = this.isValidURL(res.data)
          if (url) {
            window.location.href = res.data
          }else {
            this.sucess = true
            const index = document.querySelector('.index')
            window.scrollTo(0, index.offsetTop)
          }
        })
        .catch(err => {
          Toast(err.message || err)
        })
    },

    
    onSearchSchoolClick() {
      console.log('onSearchSchoolClick', this.$debounce)
      if (!this.schoolSearchName) {
        this.schoolList = []
        return
      }
      this.schoolList = []
      this.schoolSearchLoading = true
      const sendData = {
        keyword: this.schoolSearchName,
        college_type: this._isOversea ? 2 : 1,
        college_level: ''
      }
      api.getCollegesListOrder(sendData).then(res => {
        this.schoolList = res.data
        this.schoolSearchLoading = false
      })
    },
    onSchoolChange(id, name) {
      this.schoolSearchName = name
      this.form.sch_id = id
      this.form.school = name
      this.univNamePopupShow = false
      this.searchListShow = false
    },
    onUnivTypeConfirm(value) {
      if (value != this.form.school_type) {
        this.form.school = ''
      }
      this.form.school_type = value
      this.univTypePopupShow = false
      this.schoolSearchName = ''
    },
    onYearConfirm(value) {
      this.form.bacherlor_in_year = value
      // this.yearPopupShow = false
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      })
    },
    clickArea() {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      })
    },
    onPopupCancel() {
      this.univTypePopupShow = false
      // this.yearPopupShow = false
      this.univTypePopupShow = false
    },
    onPopupClose() {
      if (this._isOversea) {
        this.form.school = this.schoolSearchName
        this.form.sch_id = ''
        if (this.schoolList.length == 1 && this.form.school === this.schoolList[0].college_name) {
          this.form.sch_id = this.schoolList[0].id
        }
      }
    },
    openPopup(name) {
      switch (name) {
        case 'univ-type':
          this.univTypePopupShow = true
          break
        case 'univ-name':
          this.univNamePopupShow = true
          this.schoolList = []
          break
        // case 'year':
        //   this.yearPopupShow = true
        //   break
        default:
          break
      }
    },
    download() {
      window.location.href = 'https://m.compassedu.hk/app'
    },
    onFocus(event, target_ref = '') {
      this.isFocus = true
      console.log('---onFocus---', this.isFocus)

      let t1 = setTimeout(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const rec_top = !target_ref ? 0 : this.$refs[target_ref].getBoundingClientRect().top + scrollTop

        window.scrollTo({
          top: rec_top,
          behavior: 'smooth'
        })
        clearTimeout(t1)
      }, 0);
    },
    onBlur() {
      this.isFocus = false
      this.fresh = this.fresh + 1
      console.log('---onBlur---', this.fresh)

      // setTimeout(() => {
      //   if (!this.isFocus) {
      //     console.log('---onBlur---')
      //     window.scrollTo(0, 0)
      //   }
      // }, 200)
    },
    onSchoolFocus(event, target_ref = '') {
      this.searchListShow = true
      if (!this.schoolSearchName) {
        this.schoolList = []
      }
      
      let t2 = setTimeout(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const rec_top = !target_ref ? 0 : this.$refs[target_ref].getBoundingClientRect().top + scrollTop

        window.scrollTo({
          top: rec_top,
          behavior: 'smooth'
        })
        clearTimeout(t2)
      }, 0);
    },
    onSchoolBlur() {
      setTimeout(() => {
        if (!this.schoolList.length) {
          this.searchListShow = false
        }
      }, 1000)

      const school = this.schoolList.find(v => v.college_name == this.schoolSearchName)
      if (this.form.sch_id && (!school || (school && this.form.sch_id !== school.id))) {
        this.form.sch_id = ''
        this.form.school = ''
      }
      if (!this.form.sch_id && this._isOversea && this.schoolList.length) {
        this.form.school = ''
      }
      if (!this.form.sch_id && !this._isOversea) {
        //  国内本科
        // this.schoolSearchName = ''
      }
      if (!this.form.sch_id && this._isOversea && this.schoolList.length) {
        //  海外本科
        // this.schoolSearchName = ''
      }
      if (!this.form.sch_id && this._isOversea && !this.schoolList.length) {
        //  海外本科
        this.form.school = this.schoolSearchName
      }
      this.univNamePopupShow = false
    },
    // 微信相关
    isInWeChatMP() {
      console.log('isInWeChatMP')
      const ua = window.navigator.userAgent.toLowerCase()
      console.log('isInWeChatMP ua', ua)
      return new Promise(resolve => {
        if (ua.indexOf('micromessenger') == -1) {
          //不在微信或者小程序中
          console.log('不在微信或者小程序中')

          resolve(false)
        } else {
          wx.miniProgram.getEnv(function (res) {
            console.log('isInWeChatMP 22')
            if (res.miniprogram) {
              console.log('在小程序中')
              //在小程序中
              resolve(true)
            } else {
              //在微信中
              console.log('在微信中')
              resolve(false)
            }
          })
        }
      })
    },
    closeWebview() {
      wx.miniProgram.navigateBack()
    }
  }
}
</script>
<style lang="less" scoped>
@import url('~@/style/variables.less');
@import url('~@/style/mixin.less');
.index {
  .form {
    position: relative;
    padding-top: 3.02rem;
    overflow-x: hidden;
    .header-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 8.12rem;
      background: url('../assets/img/clue-header.png') no-repeat;
      background-size: 100% 100%;
    }
    .content-box {
      padding: 0.1rem 0 0.56rem;
      width: 100%;
      // height: calc(100vh - 3.02rem);
      background: rgba(255, 255, 255, 0.92);
      box-shadow: 0 0.04rem 0.4rem 0 rgba(216, 222, 230, 0.28);
      border-radius: 0.24rem 0.24rem 0 0;
      border-color: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;
      backdrop-filter: blur(0.2rem);
    }
    .title {
      font-size: 0.36rem;
      font-weight: 500;
      color: @title-color;
      padding: 0 0.36rem;
      line-height: 0.84rem;
    }
    .intro {
      font-size: 0.26rem;
      color: #8e949d;
      line-height: 0.42rem;
      padding: 0 0.78rem 0.18rem 0.36rem;
    }
    .content {
      padding: 0 0.4rem 0 0.3rem;
      .van-cell-group {
        background-color: transparent;
      }
      .form-item {
        margin-bottom: 0.24rem;
        position: relative;
        .form-item-label {
          font-weight: 500;
          font-size: 0.3rem;
          color: #4a4e54;
          line-height: 0.48rem;
          margin: 0 0 0.12rem 0.06rem;
          display: flex;
          align-items: center;
          .star-icon {
            display: inline-block;
            color: #ff701a;
            font-size: 0.32rem;
            line-height: 0.48rem;
            margin-right: 0.1rem;
          }
          .tip {
            margin-left: 0.1rem;
            display: inline-block;
            padding: 0 0.1rem;
            background: #ffece0;
            border-radius: 0.06rem;
            font-size: 0.2rem;
            color: #ff701a;
            line-height: 0.28rem;
          }
        }
        .form-item-field {
          width: 6.8rem;
          height: 0.64rem;
          background: #f5f7fa;
          border-radius: 0.12rem;
          padding: 0.08rem 0.2rem;
          text-align: start;
          /deep/.van-cell__title {
            display: flex;
            align-items: center;
            color: #4a4e54;
          }
          /deep/.van-field__control {
            color: #4a4e54;
          }
          .label-name {
            flex-shrink: 0;
          }
          .tri-icon {
            flex-shrink: 0;
            margin-left: 0.16rem;
            display: inline-block;
            width: 0;
            height: 0;
            border-left: 0.08rem solid transparent;
            border-right: 0.08rem solid transparent;
            border-top: 0.08rem solid #4a4e54;
          }
          .divide {
            flex-shrink: 0;
            margin-left: 0.22rem;
            width: 0.02rem;
            height: 0.3rem;
            background: #9a9fa3;
          }
        }
        .radio-btn-group {
          display: flex;
          flex-wrap: wrap;
          // gap: 0.2rem;
          .radio-btn {
            width: calc((100% - 0.4rem) / 3);
            height: 0.64rem;
            background: #f5f7fa;
            border-radius: 0.12rem;
            font-size: 0.26rem;
            color: #4a4e54;
            line-height: 0.48rem;
            margin-right: 0.2rem;
            margin-bottom: 0.2rem;
            border-color: #f5f7fa;
            &:nth-child(3n) {
              margin-right: 0;
            }
          }
          .radio-active-btn {
            background: #eef5ff;
            border: 0.02rem solid #0166ff;
            font-weight: 500;
          }
        }
        .check-btn-group {
          display: flex;
          flex-wrap: wrap;
          // gap: 0.2rem;
          .check-btn {
            // width: 2.14rem;
            width: 100%;
            height: 0.64rem;
            background: #f5f7fa;
            border-radius: 0.12rem;
            border: 0.02rem solid #f5f7fa;
            box-sizing: border-box;
          }
          .active-checked-btn {
            background: #eef5ff;
            border: 0.02rem solid #0166ff;
          }
          .check {
            // width: 2.14rem;
            height: 0.64rem;
            position: relative;
            display: flex;
            width: calc((100% - 0.4rem) / 3);
            margin-right: 0.19rem;
            margin-bottom: 0.2rem;
            &:nth-child(3n) {
              margin-right: 0;
            }
            /deep/.van-button::before {
              display: none;
            }
            /deep/.van-checkbox__label {
              margin-left: 0;
              line-height: normal;
              display: inline-flex;
              // width: 2.14rem;
              width: 100%;
              height: 0.64rem;
            }
            /deep/.van-checkbox__icon {
              position: absolute;
              right: 0.01rem;
              bottom: 0;
              z-index: 9;
              width: 0.44rem;
              height: 0.24rem;
              display: none;
            }
            /deep/ .van-checkbox__icon--checked {
              display: inline-block;
            }
            /deep/.van-checkbox__icon--checked .van-icon {
              width: 0.44rem !important;
              height: 0.24rem !important;
              background: #2372ff !important;
              border-radius: 0.2rem 0 0.12rem 0 !important;
              position: relative;
              /deep/.van-icon-success:before {
                position: absolute;
              }
            }
            /deep/.van-checkbox__icon .van-icon {
              border: none;
              width: 0.44rem !important;
              height: 0.24rem !important;
              line-height: 0.9;
            }
            /deep/.van-icon-success:before {
              transform: scale(0.9);
            }
            /deep/.van-button__content::before {
              display: none;
            }
          }
        }
        .school-list {
          position: absolute;
          background: #fff;
          z-index: 9;
          width: 100%;
          max-height: 4rem;
          overflow: scroll;
          box-shadow: 0 0.12rem 0.32rem 0 rgba(0, 0, 0, 0.08), 0 0.06rem 6px -0.08rem rgba(0, 0, 0, 0.12),
            0 0.18rem 0.56rem 0.16rem rgba(0, 0, 0, 0.05);
          text-align: center;
          .school-list-item {
            padding-left: 0.1rem;
            height: 0.8rem;
            line-height: 0.8rem;
            font-size: 0.3rem;
            color: @content-color;
            border-bottom: 0.02rem solid @border-color;
            &:hover {
              background: #f7f7f7;
            }
          }
          .school-list-item-selected {
            background: #f7f7f7;
          }
        }
        .school-list-empty {
          box-shadow: 0 0.12rem 0.32rem 0 rgba(0, 0, 0, 0.08), 0 0.06rem 6px -0.08rem rgba(0, 0, 0, 0.12),
            0 0.18rem 0.56rem 0.16rem rgba(0, 0, 0, 0.05);
          line-height: 1.2rem;
          font-size: 0.3rem;
          color: #8c8c8c;
          text-align: center;
        }
      }

      .popup-school {
        .popup-header {
          background: #fff;
          height: 0.8rem;
          line-height: 0.8rem;
          border-bottom: 1px solid @border-color;
          display: flex;
          justify-content: space-between;
          width: 100%;

          .popup-header__tip {
            font-size: 0.24rem;
            color: @title-color;
            margin-left: 0.3rem;
          }
          .popup-header__icon {
            width: 0.8rem;
            font-size: 0.3rem;
            color: @sub-color;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-right: 0.3rem;
            &::after {
              .icon-close;
            }
          }
        }
        .popup-body {
          padding: 0 0.3rem 0.3rem;

          .popup-search {
            font-size: 0;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            height: 1rem;
            padding: 0.18rem 0;
            background: #ffffff;
            border-bottom: 1px solid @border-color;
            .search__input {
              display: flex;
              align-items: center;
              color: @content-color;
              font-size: 0.32rem;
              width: 100%;
              background: #f7f7f7;
              border-radius: 0.1rem;
              border: 1px solid rgba(231, 231, 231, 1);
              input {
                background: transparent;
                outline: none;
                /*border: none;*/
                -webkit-tap-highlight-color: transparent;
                border: none;
                width: 100%;
                height: 0.64rem;
                font-size: 0.32rem;
                color: @sub-color;
                text-align: left;
                text-indent: 0.1rem;
              }
              input::placeholder {
                color: @sub-color;
                font-size: 0.3rem;
              }
              .search__search {
                font-size: 0.45rem;
                color: @sub-color;
                &::after {
                  .icon-search;
                }
              }
            }
            .search__cancel {
              flex-shrink: 0;
              padding-left: 0.2rem;
              color: @primary-color;
              font-size: 0.3rem;
            }
          }
          .popup-schoollist {
            height: 8rem;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch; /* ios5+ */
            .schoollist-null {
              font-size: 0.3rem;
              color: @sub-color;
              text-align: center;
              margin-top: 2rem;
            }
            .schoollist-list__item {
              padding-left: 0.1rem;
              height: 1.1rem;
              line-height: 1.1rem;
              font-size: 0.3rem;
              color: @content-color;
              border-bottom: 1px solid @border-color;
            }
            .schoollist-list__item--selected {
              background: #f7f7f7;
            }
          }
        }
      }
    }
    .bottom {
      margin-top: 0.28rem;
      padding: 0 0.32rem;
    }
  }

  .result {
    height: 100vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: hidden;
    &__logo {
      width: 6.5rem;
      height: 4.88rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &__title {
      font-size: 0.4rem;
      line-height: 0.9rem;
      color: #262626;
      font-weight: 500;
    }
    &__tip {
      margin-top: 0.18rem;
      width: 6.11rem;
      font-size: 0.3rem;
      color: #8c8c8c;
      text-align: center;
    }
    &__tip2 {
      margin-top: 0rem;
    }
    .btn-submit {
      margin-top: 0.69rem;
      width: 5.5rem;
    }
  }
  //common
  /deep/.btn-submit {
    width: 100%;
    height: 0.88rem;
    line-height: 0.88rem;
    background: linear-gradient(156deg, #0163ff 0%, #019dff 15%, #0163ff 100%) !important;
    box-shadow: 0 0.04rem 0.22rem 0 rgba(124, 174, 255, 0.56);
    border-radius: 0.16rem;
    font-size: 0.3rem;
    color: #ffffff;
    text-align: center;
    &:hover {
      // background: #1eb9ee !important;
    }
  }
  .preLine {
    white-space: nowrap;
    a {
      color: #646566;
    }
  }
}

[class*='van-hairline']::after {
  border: none;
}
</style>
